// General Containers

const navWidth = 320;
const navWidthSmall = 280;

const containerFluid = theme => ({
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    marginRight: "auto",
    marginLeft: "auto",
    width: "100%"
})

const container = theme => ({
    ...containerFluid(theme),
    maxWidth: theme.width.container,
})

const containerFluidCenter = theme => ({
    ...containerFluid(theme),
    minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
    display: 'flex',

    '&  > *': {
        margin: 'auto'
    }
})

const containerCenter = theme => ({
    ...container(theme),
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
    display: 'flex',

    '& > *': {
        margin: 'auto'
    }
})

const containerFlex = theme => ({
    ...containerFluid(theme),
    maxWidth: theme.width.container,
    display: 'flex',

    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap'
    }
})

const containerFlexFixed = theme => ({
    flexGrow: 0,
    flexBasis: `${navWidth}px`,
    flexShrink: 0,

    [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
    }
})

const containerFlexFixedSmall = theme => ({
    flexGrow: 0,
    flexBasis: `${navWidthSmall}px`,
    flexShrink: 0,

    [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
    }
})

const containerFlexGrow = theme => ({
    flexGrow: 1,

    [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
        flexGrow: 0,
    }
})

const containerFull = theme => ({
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
    backgroundColor: '#ffffff',
    overflowY: 'scroll',
    overflowX: 'scroll',
})

export {
    navWidth,
    navWidthSmall,
    containerFluid,
    container,
    containerFluidCenter,
    containerCenter,
    containerFlex,
    containerFlexFixed,
    containerFlexFixedSmall,
    containerFlexGrow,
    containerFull
};
